import React from "react";
// Billing Determinant Card

// Default
import { useState } from "react";

// Mui
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";

// Svg
import Calendar2 from "../../assets/svg/calendar2";

// Custom
import CustomSearch from "../search/Search";
import DateAndTimePopover from "../popovers/DateAndTimePopover";
import CustomDataTable from "../table/CustomTable";

const BillingDeterminant: React.FC = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [timeRange, setTimeRange] = useState<number[]>([0, 1439]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const handleDateChange = (dates: [Date, Date]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const COLUMNS = [
    "Register Rule Code",
    "Action",
    "QT-Usage Time",
    "QU-Quantity",
    "UT-Unit",
  ];

  return (
    <>
      <Card sx={{ padding: "12px 21px" }}>
        <Stack direction={"row"} gap={"20px"} justifyContent={"flex-end"}>
          <IconButton
            onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
              setAnchorEl(event.currentTarget)
            }>
            <Calendar2 />
          </IconButton>
          <CustomSearch
            placeholder={"Enter Meter id"}
            sx={{ width: "300px" }}
          />
          <CustomSearch
            placeholder={"Enter Commitment Contract id"}
            sx={{ width: "300px" }}
          />
        </Stack>
      </Card>

      <Card
        sx={{
          padding: "20px",
          maxHeight: "640px",
          minHeight: "203px",
          marginTop: "20px",
        }}>
        <CustomDataTable
          sx={{ maxHeight: "600px" }}
          columns={COLUMNS}
          rowsContent={[]}
          // totalCount={200}
          isLoading={loading}
          pagination={true}
          rowsPerPage={rowsPerPage}
          page={page}
          // rowsContent={rowsContent}
          // onPageChange={(_, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </Card>

      <DateAndTimePopover
        anchorEl={anchorEl}
        setAnchorEl={(anchorEl: HTMLElement | null) => setAnchorEl(anchorEl)}
        startDate={startDate}
        endDate={endDate}
        handleDateChange={handleDateChange}
        timeRange={timeRange}
        setTimeRange={(timeRange: number | number[]) =>
          setTimeRange(Array.isArray(timeRange) ? timeRange : [timeRange])
        }
        handleDateSubmit={() => console.log("Handle submit")}
      />
    </>
  );
};

export default BillingDeterminant;
